import _ from 'lodash';
import {usePermissions} from '../hooks/usePermissions';

const HasPermission = ({children, permission, fallbackContent = null}) => {
  const hasPermission = usePermissions(permission);
  return hasPermission || _.isUndefined(permission) ? children : fallbackContent;
}

export default HasPermission;
